import {useRouter} from 'next/router'
import type {DomainCountry} from 'src/common/types'

export const useGetDomainCountry = () => {
  const router = useRouter()
  const domainCountry = (router.locale || 'us') as DomainCountry

  return domainCountry
}
